<app-userapi-shared-non-oauth [userApi]="userApi">

  <p [innerHTML]="userApi.api.configDescription"></p>

  @if (userApi.api.configType === 'SINGLE_KEY_CUSTOM_URL') {
    <div class="flex space-x-2 mb-6">
      @if (userApi.api.urlPrefix) {
        <div class="my-auto">{{ userApi.api.urlPrefix }}</div>
      }
      <div class="w-full">
        <FloatingLabelInput
            id="url"
            [appColor]="appColor()"
            [label]="userApi.api.url"
            [(myValue)]="userApi.url"
        ></FloatingLabelInput>
      </div>
      @if (userApi.api.urlPostfix) {
        <div class="my-auto">{{ userApi.api.urlPostfix }}</div>
      }
    </div>
  }

  <FloatingLabelInput
      id="publicKey"
      [appColor]="appColor()"
      [label]="userApi.api.placeholder1 | translate: { api: userApi.api.name }"
      [(myValue)]="userApi.publicKey"
      (myValueChange)="userApi.configured = !!userApi.publicKey"
  ></FloatingLabelInput>

  @if (userApi.api.internalKey === 'Yuki') {
    <InfoCard
        titleKey="USERAPI_CONNECTION_HELP_TITLE_YUKI"
        bodyKey="USERAPI_CONNECTION_HELP_BODY_YUKI"
    ></InfoCard>
  }

  @if (userApi.api.internalKey === 'eboekhouden' && userApi.publicKey?.length > 3 && userApi.publicKey.length < 30) {
    <InfoCard
        titleKey="USERAPI_CONNECTION_HELP_TITLE_EBOEKHOUDEN"
        bodyKey="USERAPI_CONNECTION_HELP_BODY_EBOEKHOUDEN"
    ></InfoCard>
  }

  @if (userApi.api.internalKey === 'Stripe' && userApi.publicKey?.length > 8 && userApi.publicKey.indexOf('_live_') === -1 && userApi.publicKey.indexOf('_test_') === -1) {
    <InfoCard
        titleKey="USERAPI_CONNECTION_HELP_TITLE_STRIPE_INVALID"
        bodyKey="USERAPI_CONNECTION_HELP_BODY_STRIPE_INVALID"
    ></InfoCard>
  }

</app-userapi-shared-non-oauth>